import { useAppContext } from "../contexts/AppContext";
import { useState } from "react";
import { toast } from "react-toastify";
const useTasks = () => {
    const { tasks, setTasks } = useAppContext();
    const [justCompletedTasks, setJustCompletedTasks] = useState([]); // Array to hold tasks for animation

    const isOverdue = (dueDate) => {
        const today = new Date();
        const due = new Date(dueDate);
        return due < today;
    };

    const handleCheckboxChange = (taskId) => {
        const updatedTasks = tasks.map((task) =>
            task.id === taskId ? { ...task, completed: !task.completed } : task
        );

        setTasks(updatedTasks);

        const justCompleted = updatedTasks.find((task) => task.id === taskId && task.completed);
        if (justCompleted) {
            // Add to justCompletedTasks for animation
            setJustCompletedTasks((prev) => [...prev, taskId]);

            setTimeout(() => {
                // Remove the task from the animation list after 1s
                setJustCompletedTasks((prev) => prev.filter((id) => id !== taskId));
            }, 1000);
            toast.success("Task completed");
        } else {
            // Directly remove from justCompletedTasks if it's unchecked
            setJustCompletedTasks((prev) => prev.filter((id) => id !== taskId));
        }
    };

    

    return {
        handleCheckboxChange,
        isOverdue,
        justCompletedTasks,
    };
};

export default useTasks;
